"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeHtmlTags = void 0;
var removeHtmlTags = function (comment) {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = comment === null || comment === void 0 ? void 0 : comment.replace(/<[^>]*>/g, "")) === null || _a === void 0 ? void 0 : _a.replace(/&nbsp;/g, " ")) === null || _b === void 0 ? void 0 : _b.replace(/\[\d+\]/g, "")) === null || _c === void 0 ? void 0 : _c.replace(/\s+/g, " ")) === null || _d === void 0 ? void 0 : _d.trim();
};
exports.removeHtmlTags = removeHtmlTags;
